"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.COUNTRY_INPUTS_CONTAINER = exports.STREET_INPUTS_CONTAINER = exports.INPUTS_CONTAINER = exports.MANUAL_LOCATION_FORM = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var FORM_MARGIN_TOP = {
  marginTop: "15px"
},
    MANUAL_LOCATION_FORM = (0, _cxs["default"])(_objectSpread({}, FORM_MARGIN_TOP, {
  width: "100%"
}));
exports.MANUAL_LOCATION_FORM = MANUAL_LOCATION_FORM;
var INPUTS_CONTAINER = (0, _cxs["default"])(_objectSpread({
  display: "flex"
}, FORM_MARGIN_TOP, (0, _defineProperty2["default"])({
  " > label": {
    display: "block"
  },
  " > label:not(:first-child)": {
    marginLeft: "10px"
  }
}, _vars.MEDIA_QUERIES.small, {
  flexDirection: "column",
  " > label:not(:first-child)": {
    marginLeft: "0",
    marginTop: "15px"
  },
  " > label": {
    width: "100%!important"
  }
})));
exports.INPUTS_CONTAINER = INPUTS_CONTAINER;
var STREET_INPUTS_CONTAINER = (0, _cxs["default"])({
  " > label:first-child": {
    width: "25%"
  }
});
exports.STREET_INPUTS_CONTAINER = STREET_INPUTS_CONTAINER;
var COUNTRY_INPUTS_CONTAINER = (0, _cxs["default"])({
  " > label:nth-child(1)": {
    width: "50%"
  },
  " > label:nth-child(2)": {
    width: "25%"
  },
  " > label:nth-child(3)": {
    width: "25%"
  }
});
exports.COUNTRY_INPUTS_CONTAINER = COUNTRY_INPUTS_CONTAINER;